import { useState } from 'react'
import styled from 'styled-components/macro'

/** Approximate banner height for App body top padding (banner may wrap to 2 lines). */
export const DISCLAIMER_BANNER_HEIGHT = '52px'

// UZH Berry, solid, with white text
const BANNER_BG = '#BF0D3E' // UZH Berry
const BANNER_TEXT = '#FFFFFF' // UZH White
const BANNER_BORDER = '#8F0A2E' // UZH Berry V4

const LINE_1 = 'Deployment purely for educational purposes at University of Zurich (Switzerland).'
const LINE_2 =
  'This is not the official Uniswap on any public blockchain. Do not use any official credentials in this website.'

const Banner = styled.div`
  position: relative;
  z-index: 3;
  background-color: ${BANNER_BG};
  color: ${BANNER_TEXT};
  border-bottom: 1px solid ${BANNER_BORDER};
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  padding: 10px 44px 10px 16px;
  box-sizing: border-box;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 11px;
  `};
`

const Strong = styled.strong`
  font-weight: 700;
`

const CloseButton = styled.button`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: ${BANNER_TEXT};
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  padding: 0;

  &:hover {
    background-color: rgba(255, 255, 255, 0.15);
  }
`

/**
 * Teaching-site notice for IT / Safe Browsing.
 * UZH Berry styling; dismissible for the current visit only (React state).
 */
export default function DisclaimerBanner({ onDismiss }: { onDismiss?: () => void } = {}) {
  const [dismissed, setDismissed] = useState(false)

  // To persist dismissal across reloads, use:
  // const [dismissed, setDismissed] = useState(
  //   () => localStorage.getItem('uzhswap-disclaimer-dismissed') === 'true'
  // )
  // and in the onClick below, also call:
  // localStorage.setItem('uzhswap-disclaimer-dismissed', 'true')

  if (dismissed) return null

  return (
    <Banner role="status">
      <span>
        <Strong>Disclaimer:</Strong> {LINE_1}
        <br />
        {LINE_2}
      </span>
      <CloseButton
        onClick={() => {
          setDismissed(true)
          onDismiss?.()
        }}
        aria-label="Dismiss disclaimer"
      >
        &times;
      </CloseButton>
    </Banner>
  )
}
